const typographyFormParamEquipService = {
  text: 'Equipment Services',
  text1: 'Select a site',
  inactive: 'Inactive',
};

export default typographyFormParamEquipService;
